import { graphSitesUiSlice } from '@features/DataView/Graph/store/GraphSitesUIReducer';
import { combineReducers } from '@reduxjs/toolkit';
import {
  allSitesUiSlice,
  userSitesUiSlice,
  selectedSitesUiSlice,
} from '@shared/components/Sidebar/SiteList/store/SitesUIReducer';
import { preferencesReducer } from './entity/preferences/PreferencesReducer';
import { siteReducer } from './entity/sites/SitesReducer';
import { accountsReducer } from './library-stores/accounts';
import { userProfileReducer } from './library-stores/user-profile';

const rootReducer = combineReducers({
  [accountsReducer.slice.name]: accountsReducer.slice.reducer,
  [userProfileReducer.slice.name]: userProfileReducer.slice.reducer,
  [siteReducer.slice.name]: siteReducer.slice.reducer,
  [preferencesReducer.slice.name]: preferencesReducer.slice.reducer,
  [userSitesUiSlice.name]: userSitesUiSlice.reducer,
  [allSitesUiSlice.name]: allSitesUiSlice.reducer,
  [selectedSitesUiSlice.name]: selectedSitesUiSlice.reducer,
  [graphSitesUiSlice.name]: graphSitesUiSlice.reducer,
});

export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
